module.exports = __webpack_public_path__ + "static/media/bajajThankyouScreenLogo.dc333b00.svg";